import React from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";

import AdminLayout from "layouts/admin";
import AuthLayout from "layouts/auth";
import SeoLayout from "layouts/seo";

// Компонент для автоматической прокрутки вверх при смене маршрута
const ScrollToTop = () => {
  const { pathname } = useLocation();

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

const App = () => {
  return (
    <AuthProvider>
      <ScrollToTop />
      <Routes>
        <Route path="auth/*" element={<AuthLayout />} />
          <Route 
            path="admin/*" 
            element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            } 
          />

          <Route 
            path="/seo/*" 
            element={
              <ProtectedRoute>
                <SeoLayout />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/" 
            element={
              <ProtectedRoute>
                <Navigate to="/seo/dashboard" replace />
              </ProtectedRoute>
            }
          />
      </Routes>
    </AuthProvider>
  );
};

export default App;
